module.exports = __webpack_public_path__ + "static/media/Send.3edcbe2d.svg";